<template lang="jade">
  .Chart
    .Chart__header
      h2.Chart__title Current claims and benefit entitlement
    .Chart__body
      .Chart__content
        .Chart__wrapper
          .Chart__heading Benefit Amount
          .Chart__labels
              .Chart__row(v-for="item in fdata.chart")
                .Chart__label {{ item.title }} 
          .Chart__bars
            .Chart__x-axis
              .Chart__col(v-for="n in fdata.columns")
                .Chart__unit {{n}}
            .Chart__y-axis
              .Chart__row(v-for="item in fdata.chart") 
                .Chart__bar(":style"="$index | delay"
                            @click="dialog(item.workflow)")
                  .Chart__claimed(":style"="item.claimed | calcWidth"
                                  @mouseover="setTooltip($event, item, claimed)"
                                  @mouseout="disableTooltip")
                  .Chart__remaining(":style"="item.limit | calcWidth"
                                    @mouseover="setTooltip($event, item, claimable)"
                                    @mouseout="disableTooltip")       
        .Chart__aside
          div
            div(style="text-align: center; padding-bottom: 41px; font-weight: 600;color: #a6a6a6; width: 200px")
              span(style="width: 50%; padding: 0 10px; display: inline-block") Benefit Year ends 
              span(style="width: 50%; padding: 0 10px; display: inline-block") Maximum Claimable
            div.Chart__row(v-for="item in fdata.chart")
              span.Chart__name {{ item.title }}
              span.Chart__expires {{ item.expires | date }}
              span.Chart__limit up to {{ item.limit | currency }}
    .Chart__footer(style="display: flex")
      .DotChart(v-for="item in fdata.hospitality")
        .DotChart__header
          .DotChart__title 
            {{ item.title }} 
            span.DotChart__meta {{ item | format }}
        .DotChart__body
          .DotChart__circle(class="DotChart__circle--claimed" v-for="n in item.claimed"
                            @click="dialog(item.workflow)"
                            @mouseover="setTooltip($event, item, claimed2)"
                            @mouseout="disableTooltip")
          .DotChart__circle(v-for="n in item.remaining"
                            @mouseover="setTooltip($event, item, claimable2)"
                            @mouseout="disableTooltip")  
    .Tooltip(v-bind:class="{'Tooltip--is-visible': tooltip.show, 'Tooltip--is-hidden': !tooltip.show}" 
             v-el:tooltip)
      p.Tooltip__text(v-html="tooltip.text") 
</template>
<script>
  import Moment from 'moment'
  import {addDynamicWorkflow,
          addNotification,
          addWorkflow} from 'src/vuex/actions'
  import {workflow} from 'src/vuex/getters'

  export default {
    data () {
      return {
        uid: this.$parent.uid,
        interval: null,
        cursor: {x: 0, y: 0, prev: {x: 0, y: 0}},
        tooltip: {show: false, text: ''},
        units: {
          'Daycase Admission': 'DAYS',
          'Hospital': 'NIGHTS'
        }
      }
    },
    props: {
      fdata: {
        type: Object,
        coerce (x) {
          let [chart, hospitality] = x.content
          chart = _.map(chart.content, xs => {
            let [title, remaining, limit, expires, workflow] = xs.content
            return {
              title: title.value,
              claimed: parseFloat(limit.value) - parseFloat(remaining.value),
              remaining: parseFloat(remaining.value),
              limit: parseFloat(limit.value),
              expires: expires.value,
              workflow: workflow.content[0]
            }
          })

          let max = Math.ceil(_.reduce(chart, (a, b) => Math.max(a, b.limit), 0))
          let step = Math.ceil((max / 10))

          hospitality = _.map(hospitality.content, xs => {
            let [title, remaining, limit, workflow] = xs.content
            return {
              title: title.value,
              claimed: parseInt(limit.value) - parseInt(remaining.value),
              remaining: parseInt(remaining.value),
              limit: parseInt(limit.value),
              workflow: workflow.content[0]
            }
          })

          return {
            chart,
            max,
            columns: _.range(step, (max + step), step),
            hospitality: hospitality.filter(xs => !_.isNaN(xs.claimed))
          }
        },
        required: true
      }
    },
    filters: {
      calcWidth (x) {
        let width = (x / this.fdata.max) * 100
        return {
          width: `${width}%`
        }
      },
      currency (x) {
        return `£${x.toFixed(2)}`
      },
      date (x) {
        return Moment(x).format('DD MMM YYYY')
      },
      delay (x) {
        return {
          'animation-delay': `0.${x}s`
        }
      },
      format (o) {
        let unit = _.has(this.units, o.title) ? this.units[o.title] : 'SESSIONS'
        return `MAX ${o.limit} ${unit}`
      }
    },
    vuex: {
      actions: {
        dynamicWorkflow: addDynamicWorkflow,
        addNotification,
        addWorkflow
      },
      getters: {
        workflow
      }
    },
    computed: {
      claimable () {
        return _.template('Claimable <strong>£<%= remaining.toFixed(2) %></strong>')
      },
      claimed () {
        return _.template('Used <strong>£<%= claimed.toFixed(2) %></strong><span>Claim Details</span>')
      },
      claimable2 () {
        return _.template('Claimable <strong><%= remaining %></strong>')
      },
      claimed2 () {
        return _.template('Used <strong><%= claimed %></strong><span>Claim Details</span>')
      },
      headers () {
        let workflow = _.find(this.workflow, ['uid', this.uid])
        return {
          headers: {
            'X-FORMID': workflow.fid,
            'X-FINGERPRINT': workflow.fingerprint,
            'X-SITEID': this.fdata.siteId || workflow.sid
          }
        }
      }
    },
    methods: {
      setTooltip (e, item, fn) {
        this.$set('tooltip', {show: true,
                              text: fn(item)})
      },
      setCursorPosition (e) {
        let coords = { x: e.clientX, y: e.clientY }
        this.$set('cursor', Object.assign({}, this.cursor, coords))
      },
      setTooltipPosition () {
        let {tooltip} = this.$els
        let {x, y} = this.cursor
        tooltip.style.top = `${y + 20}px`
        tooltip.style.left = `${x - 100}px`
      },
      disableTooltip () {
        this.$set('tooltip.show', false)
        window.clearInterval(this.interval)
        setTimeout(() => {
          let {tooltip} = this.$els
          let {x, y} = this.cursor
          tooltip.style.top = `${y + 20}px`
          tooltip.style.left = `${x - 5000}px`
          this.$set('interval', window.setInterval(this.setTooltipPosition, 40))
        }, 500)
      },
      dialog (wf) {
        this.dynamicWorkflow({
          wid: wf.workflowId,
          fkey: this.uid,
          params: { workflowParameters: wf.workflowParameters,
                    dbWorkflowKey: wf.dbWorkflowKey },
          sid: wf.siteId,
          headers: this.headers,
          button: wf
        })
      }
    },
    ready () {
      document.addEventListener('mousemove', this.setCursorPosition)
      this.$set('interval', window.setInterval(this.setTooltipPosition, 40))
    }
  }
</script>



// WEBPACK FOOTER //
// bar.vue?707eb72e